import { useChecklistStore, useSoggettoStore } from "../store/crm.store";
import {cloneDeep} from "lodash";

export function useRefreshChecklist() {
  const checklistStore = useChecklistStore()
  const soggettoStore = useSoggettoStore()

  /**
   * Ricarico le checklist, utilizzato ad esempio nel momento di primo invio di una checklist ad un soggetto
   * @param soggettoID
   * @param responseQuestionariRichiestiParams
   * @returns {Promise<void>}
   */
  const refreshChecklist = async (soggettoID, responseQuestionariRichiestiParams = null) => {
    await checklistStore.onResponseQuestionariRichiesti(responseQuestionariRichiestiParams);
    checklistStore.is_show_checklist = false;

    setTimeout(() => {
      checklistStore.is_show_checklist = true
    }, 100)

    let soggettiVuex = cloneDeep(soggettoStore.store_soggetti);
    let soggettiVuexDefault = cloneDeep(soggettoStore.store_soggetti);

    soggettiVuex.forEach(function (item) {
      if (item.soggetto_id === soggettoID) item.lighting = true;
    });

    soggettoStore.store_soggetti = soggettiVuex

    setTimeout(function () {
      soggettoStore.store_soggetti = soggettiVuexDefault
    }, 6000);
  }

  return {
    refreshChecklist
  }
}